export default "__VITE_ASSET__DwSNXxZf__"